module.exports = __webpack_public_path__ + "static/media/500-vector-girl-color.01b1b436.png";